import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import TestingRawDataTab from "./TestingRawDataTab";
import TestingEquipmentUsageTab from "./TestingEquipmentUsageTab";

const LOG_BOOK_TABS = [
  { key: "rawdata", label: "Raw Data", icon: "la la-flask" },
  { key: "equipment", label: "Equipment Usage", icon: "la la-cogs" },
];

// Large touch targets for tablet use; the open tab is a solid filled tab so it is obvious which one is active
const tabLinkStyle = (isActive) => ({
  minHeight: "56px",
  fontSize: "1.1rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: isActive ? 700 : 400,
  color: isActive ? "#fff" : "#6c757d",
  backgroundColor: isActive ? "var(--primary)" : "#f1f3f5",
  borderColor: isActive ? "var(--primary)" : "#dee2e6",
});

const TestingRawDataLogBook = () => {
  const [activeTab, setActiveTab] = useState("rawdata");

  return (
    <div className="card m-1 raw-data-log-book">
      <div className="card-body p-1">
        <div className="tbl-caption p-2">
          <h4 className="heading mb-0">Testing Raw Data Log Book</h4>
          <Link to="/testing-result" className="btn btn-outline-primary btn-sm">
            <i className="fa-solid fa-gauge me-2"></i>Dashboard
          </Link>
        </div>
        <hr className="mt-0 mb-1"></hr>
        <div className="p-2 pt-0 pb-0">
          <div className="default-tab">
            <Tab.Container activeKey={activeTab} onSelect={(key) => key && setActiveTab(key)}>
              <Nav as="ul" className="nav-tabs nav-fill">
                {LOG_BOOK_TABS.map((tab) => (
                  <Nav.Item as="li" key={tab.key}>
                    <Nav.Link eventKey={tab.key} style={tabLinkStyle(activeTab === tab.key)}>
                      <i
                        className={`${tab.icon} me-2`}
                        style={{ color: activeTab === tab.key ? "#fff" : undefined }} // theme paints icons in the primary colour, same as the active fill
                      />
                      {tab.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <Tab.Content className="pt-3">
                <Tab.Pane eventKey="rawdata">
                  <TestingRawDataTab />
                </Tab.Pane>
                <Tab.Pane eventKey="equipment">
                  <TestingEquipmentUsageTab />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestingRawDataLogBook;
